import React, { useState, useEffect } from "react";
import { Menu, ShoppingBag, X, Globe } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useLang } from "@/context/LanguageContext";
import { STRINGS } from "@/i18n";

export default function Header() {
  const { count, setOpen } = useCart();
  const { lang, toggle } = useLang();
  const [mobile, setMobile] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const t = STRINGS[lang].nav;

  const LINKS = [
    { label: t.catalog, href: "#catalogo" },
    { label: t.services, href: "#servicios" },
    { label: t.experience, href: "#experiencia" },
    { label: t.solutions, href: "#soluciones" },
    { label: t.testimonials, href: "#testimonios" },
    { label: t.contact, href: "#contacto" },
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "backdrop-blur-xl bg-black/70 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="px-6 md:px-12 lg:px-24 h-20 flex items-center justify-between">
        <a href="#top" data-testid="brand-logo" className="font-display text-lg md:text-xl tracking-tight">
          Valientes <span className="italic text-muted-foreground">Cenizas</span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} className="text-sm text-muted-foreground hover:text-foreground transition-opacity">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="lang-toggle-button"
            onClick={toggle}
            className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-opacity border border-white/15 rounded-full px-3 py-1.5"
            aria-label="Cambiar idioma / Switch language"
          >
            <Globe className="h-4 w-4" />
            <span className="font-mono uppercase">{lang === "es" ? "EN" : "ES"}</span>
          </button>
          <button
            data-testid="open-cart-button"
            onClick={() => setOpen(true)}
            className="relative p-2 hover:opacity-70 transition-opacity"
            aria-label="cart"
          >
            <ShoppingBag className="h-5 w-5" />
            {count > 0 && (
              <span data-testid="cart-count" className="absolute -top-0.5 -right-0.5 h-4 w-4 rounded-full bg-primary text-primary-foreground text-[10px] font-bold flex items-center justify-center">
                {count}
              </span>
            )}
          </button>
          <button className="lg:hidden p-2" onClick={() => setMobile((m) => !m)} aria-label="menu" data-testid="mobile-menu-button">
            {mobile ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {mobile && (
        <div className="lg:hidden backdrop-blur-xl bg-black/90 border-b border-white/10 px-6 py-6 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setMobile(false)} className="text-sm text-muted-foreground hover:text-foreground">
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
